'use strict';

var React = require('react');

var SvgColumns3Major = function SvgColumns3Major(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-16a2 2 0 0 0-2-2h-16Zm16 2h-4v16h4v-16Zm-10 0h4v16h-4v-16Zm-2 0h-4v16h4v-16Z"
  }));
};

exports.SvgColumns3Major = SvgColumns3Major;
